var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:"plotContainer",staticClass:"plot-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }